import getDisplayName from 'recompose/getDisplayName';
export default (function (Component) {
  var name = getDisplayName(Component);
  return name === 'Component' && Component.type ? getDisplayName(Component.type) : name;
});